import React, { useMemo, useState } from 'react';
import { sum } from 'lodash';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import MuiFilterIcon from '@material-ui/icons/FilterList';
import MoreIcon from '@material-ui/icons/MoreVert';

import ExportIcon from '../../assets/icons/DownloadBrowserIcon';
import EditIcon from '../../assets/icons/EditIcon';
import FilterOffIcon from '../../assets/icons/FilterOffIcon';

import Button from '../shared/Button';
import ColorButton from '../shared/ColorButton';

import { formatPrice } from '../../utils/utils';

import userRoles from '../../constants/userRoles';

import './sales.scss';

const StyledMenuItem = withStyles((theme) => ({
  root: {
    paddingTop: '12px',
    paddingBottom: '12px',
    color: 'var(--app-text)',
  },
}))(MenuItem);

const LostLeadsPageActions = (props) => {
  const {
    userRole,
    stages = [],
    leads = [],
    selectedPipeline,
    editMode,
    onEditClick,
    onSaveChangesClick,
    onCancelClick,
    onExportClick,
    exportLoading,
    loading,
    onFilterClick,
    activeFilterCount = 0,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const totalValue = useMemo(() => sum(
    stages.map((stage) => (
      stage.probability ? (
        sum(leads?.filter((l) => l.stage === stage.id).map((l) => l.anticipatedValue || 0)) * (stage.probability / 100) || 0
      ) : 0
    ))
  ), [stages, leads]);

  return (
    <div className='sales-page__actions'>
      {!!selectedPipeline ? (
        editMode ? (
          <div className='d-flex'>
            <ColorButton
              onClick={onSaveChangesClick}
              color='blue'
              text="Save Changes"
              fontSize={14}
              height={60}
              disabled={loading}
              loading={loading}
            />
            <div className='m-l-md'>
              <ColorButton
                onClick={onCancelClick}
                color='grey'
                text="Cancel"
                fontSize={14}
                height={60}
              />
            </div>
          </div>
        ) : (
          <div className="page-title d-flex" style={{ marginBottom: 0 }}>Lost Leads</div>
        )
      ) : (
        <div />
      )}

      <div className="d-flex">
        <div className='lost-leads-page__leads-info'>
          <div className='d-flex m-r-lg'>
            <FilterOffIcon color="var(--app-text)" />
            <div className='font-bold m-l-md'>Lost Leads</div>
          </div>
          <div className='d-flex'>
            {`${leads.length} | $${formatPrice(totalValue, 0)}`}
          </div>
        </div>

        <div className="m-l-md sales-page__filter-button">
          <Button
            type="icon"
            onClick={onFilterClick}
          >
            <MuiFilterIcon style={{ color: 'var(--app-text)' }} />
          </Button>
          {!!activeFilterCount && (
            <div className='sales-page__filter-count'>{activeFilterCount}</div>
          )}
        </div>

        {userRole === userRoles.ADMIN.name && (
          <>
            <div className="m-l-md">
              <Button
                type="icon"
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
                disabled={exportLoading}
                loading={exportLoading}
              >
                <MoreIcon style={{ color: 'var(--app-text)' }} />
              </Button>
            </div>

            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  // maxHeight: ITEM_HEIGHT * 4.5,
                  width: 200,
                },
                elevation: 3,
              }}
            >
              <StyledMenuItem
                disabled={!selectedPipeline}
                onClick={() => {
                  handleClose();
                  onExportClick();
                }}
              >
                <ExportIcon color="var(--app-text)" />
                <span className="m-l-md">Export All</span>
              </StyledMenuItem>
              <StyledMenuItem
                disabled={!selectedPipeline}
                onClick={() => {
                  handleClose();
                  onEditClick();
                }}
              >
                <EditIcon color="var(--app-text)" />
                <span className="m-l-md">Edit Pipeline</span>
              </StyledMenuItem>
            </Menu>
          </>
        )}
      </div>
    </div>
  );
};

export default LostLeadsPageActions;
